<button
  mat-icon-button
  class="user-trigger-btn"
  [class.user-trigger-btn--open]="trigger.menuOpen"
  [class.user-trigger-btn--compact]="isTabletPanel()"
  [matMenuTriggerFor]="userMenu"
  #trigger="matMenuTrigger"
  [attr.aria-label]="'userMenu.account.title' | translate"
>
  @if (isTabletPanel()) {
    <claas-icon namespace="cc" iconId="648619" [size]="24"></claas-icon>
  } @else {
    <span class="user-initials">{{ userInitials() }}</span>
  }
</button>

<mat-menu
  #userMenu="matMenu"
  xPosition="before"
  class="user-overlay-menu"
  [backdropClass]="'user-overlay-backdrop'"
>
  <!-- User avatar + name -->
  <div class="user-info">
    <div class="user-info__avatar">{{ userInitials() }}</div>
    <div class="user-info__name">{{ store.userName() }}</div>
  </div>

  <mat-divider></mat-divider>

  <!-- Actions -->
  <button mat-menu-item (click)="openChangePassword()">
    <claas-icon
      matMenuItemIcon
      class="menu-item-icon"
      namespace="cc"
      iconId="648466"
      [size]="24"
    ></claas-icon>
    <span>{{ "userMenu.changePassword" | translate }}</span>
  </button>

  <button mat-menu-item (click)="openChangeCountry()">
    <claas-icon
      matMenuItemIcon
      class="menu-item-icon"
      namespace="cc"
      iconId="001682"
      [size]="24"
    ></claas-icon>
    <span
      >[{{ "country." + store.country() | translate }}]
      {{ "userMenu.changeCountry" | translate }}</span
    >
  </button>

  <button mat-menu-item (click)="openChangeLanguage()">
    <claas-icon
      matMenuItemIcon
      class="menu-item-icon"
      namespace="cc"
      iconId="471837"
      [size]="24"
    ></claas-icon>
    <span
      >[{{ "language." + store.language() | translate }}]
      {{ "userMenu.changeLanguage" | translate }}</span
    >
  </button>

  <mat-divider></mat-divider>

  <!-- Logout -->
  <div class="overlay-logout">
    <claas-button
      [buttonClass]="buttonClass.SECONDARY_OUTLINE"
      [stretch]="true"
      (click)="logout()"
      ><claas-icon iconId="017765" namespace="cc" iconStyle="bold" />{{
        "userMenu.logout" | translate
      }}</claas-button
    >
  </div>

  <mat-divider></mat-divider>

  <!-- Footer links -->
  <div class="overlay-links">
    @for (link of footerLinksStore.items(); track link.route ?? link.label) {
      @if (link.action) {
        <a
          class="overlay-link"
          tabindex="0"
          (click)="link.action()"
          (keydown.enter)="link.action()"
          >{{ link.label }}</a
        >
      } @else {
        <a class="overlay-link" [routerLink]="link.route">{{ link.label }}</a>
      }
    }
  </div>
</mat-menu>
